import React, { Component } from 'react'
import PropTypes from 'prop-types'

import './style.scss'
/**
 * link item
 * @augments {Component<Props, State>}
 */
class LinkItem extends Component {
  static propTypes = {
    text: PropTypes.string.isRequired,
    active: PropTypes.bool,
    onClick: PropTypes.func
  }

  render() {
    const { text, active, onClick } = this.props;
    const className = ['link-item'];
    active && className.push('active');
    return (
      <div className={className.join(' ')} onClick={onClick && onClick()}>
        {text}
      </div>
    )
  }
}

export default LinkItem